import { render } from "./Detail_service.vue?vue&type=template&id=b5911438"
import script from "./Detail_service.vue?vue&type=script&lang=js"
export * from "./Detail_service.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__